import ContactForm from '../components/ContactForm';
export default (function (w, d) {
    'use strict';

    function ContactController() {
        this.initController();
    }

    ContactController.prototype.initController = function () {
        new ContactForm;
    }

    return ContactController;
}(window, document));

